import React, { lazy } from 'react';



import { createStore, applyMiddleware, compose } from 'redux'; //Creates a redux store that holds the complete state tree of your app. Compose is used to combine multiple "store enhancers" together (kind of like connect).  This is necessary to allow Firebase and Firestore connections to this app.
import rootReducer from '../store/reducers/rootReducer'; //The root reducer is the combination of all reducers of the app.
import { Provider } from 'react-redux' //Binding Layer. Surrounds the app and gives the application access to the Redux Store.
import thunk from 'redux-thunk' //redux-thunk is Middleware that is used to allow for asyncronous interactions / actions to the database.

//Needed to make slight adjustment to connect to Firebase and Firestore. Added "createFirestoreInstance"
import { reduxFirestore, getFirestore, createFirestoreInstance } from 'redux-firestore' //Allows redux to connect to firestore. reduxFirestore() is a store enhancer.

//Needed to make slight adjustment to connect to Firebase and Firestore. Added "ReactReduxFirebaseProvider"
import { getFirebase } from 'react-redux-firebase' //Allows redux to connect to firebase database. reactReduxFirebase() is a store enhancer.
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import firebaseConfig from '../config/firebaseConfiguration'

//Needed to include this to allow the website to connect to firebase.
import firebase from 'firebase/app';
import '../index.css';

//const TRACKING_ID = "G-PVQTRP6FS3"; // YOUR_OWN_TRACKING_ID
//ReactGA.initialize(TRACKING_ID);

const AppwithAuthandRouter = lazy(() => import('./AppwithAuthandRouter'));



//Creates the Redux store and stores it in reduxStore. Passes in the root reducer to the store.
//Apply/enhances the reduxStore with Middleware thunk to allow for asyncronous tasks in the reduxStore.
//Add "withExtraArgument" onto the 'thunk' to allow connection of firebase/firestore functions.
const reduxStore = createStore(
  rootReducer,
  compose(//Add compose here to combine multiple Store Enhancers like "thunk", "getFirebase" and "getFirestore"
    applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore })),
    reduxFirestore(firebase, firebaseConfig), //This is a "store enhancer" functions that take in the configuration info of Firebase/Firestore and allow the store to connect to it.
  )
);


// store.replaceReducer(newRootReducer)
//This content is added beyond the tutorial.  This is necessary to connect
//to the firebase database.
//The multiple calls of "config" is a problem.  Need to find a better way of linking up Firebase Profile info.
const rrfProps = {
  firebase,
  config: firebaseConfig,

  dispatch: reduxStore.dispatch,
  createFirestoreInstance
};



const OptimizedApp = () => {
  return (
    <Provider store={reduxStore}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <AppwithAuthandRouter />
      </ReactReduxFirebaseProvider>
    </Provider>
  )
}

export default OptimizedApp
